import React, { Component } from 'react';

class SelectDropdown extends Component {
    render() {
        return (
            <div class={`custom-select align-left ${this.props.styleClass}`} style={this.props.parentDivStyle}  >
                <div className="select-selected" onClick={this.props.setShowList} style={this.props.childDivStyle}>{this.props.selectedItem ? this.props.selectedItem : this.props.selectLabel || "Please select"}</div>
                    {this.props.showList && <div className="select-items" >
                        {
                            this.props.listData.map((obj,index) => {
                                return (
                                    <div
                                        onClick={() => this.props.setSelectedItem(obj)}>
                                        {eval(this.props.selectKey)}
                                    </div>
                                )
                            })
                        }
                    </div>}                
            </div>
        );
    }
}

export default SelectDropdown;